module.exports = __webpack_public_path__ + "static/media/vidal5.60e84f57.png";